import { useSelector } from 'react-redux';
import RoadiesShell from './RoadiesShell';
import { useIsMobile } from './hooks';

// happy-holiday-thankyou: "HAPPY HOLIDAYS!" over a festive cream background, then the score line
// "Your score is <total_score> out of 24 in <mm:ss> minutes." (submit.php's round-8 message).
export default function RoadiesThankyou() {
  const game = useSelector((s) => s.roadies.game);
  const mobile = useIsMobile();
  const time = (() => {
    const parts = String(game?.time || '').split(':');
    return parts.length === 3 ? `${parts[1]}:${parts[2]}` : game?.time || '00:00';
  })();
  return (
    <RoadiesShell stage="thankyou" bgUrl={mobile ? '/roadies/img/Happy_Holidays_BG_Mobile.png' : '/roadies/img/happy-holiday-bg.png'} className="rd-thankyou">
      <div className="rd-thankyou-inner">
        <img
          className="rd-happy-title"
          src="/roadies/img/Happy_Holiday-title.gif"
          alt="Happy Holidays!"
        />
        <div className="rd-thankyou-score">
          Your score is {game?.totalScore ?? 0} out of 24 in {time} minutes.
        </div>
      </div>
    </RoadiesShell>
  );
}
